import { render, staticRenderFns } from "./ProofOfRelative.vue?vue&type=template&id=03262b92&"
import script from "./ProofOfRelative.vue?vue&type=script&lang=js&"
export * from "./ProofOfRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports